import { Control } from 'react-hook-form';
import { FormTextarea } from '@/components/Common/FormFields';

type AdditionalSectionProps = {
  control: Control<any>;
  isPaidInitial: boolean;
  commentsLength: number;
};

const AdditionalSection: React.FC<AdditionalSectionProps> = ({
  control,
  isPaidInitial,
  commentsLength
}) => {
  return (
    <table className='table-fixed w-full border border-gray-300 rounded-xl text-sm text-center mx-auto mb-4'>
      <colgroup>
        <col style={{ width: '100%' }} />
      </colgroup>
      <thead className='bg-blue-100 text-gray-800'>
        <tr>
          <th className='min-w-[120px] py-2 px-2.5 border'>Comment</th>
        </tr>
      </thead>

      <tbody className='bg-white divide-y divide-gray-200'>
        <tr className='bg-white hover:bg-gray-50'>
          <td className='border px-2 py-1.5 align-middle'>
            <FormTextarea
              name='comments'
              control={control}
              label=''
              maxLength={250}
              disabled={isPaidInitial}
              characterCount={commentsLength}
              className={'border-1'}
              row={1}
            />
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default AdditionalSection;
